<ng-container *ngIf="1 && router.url !== '/peak'">
  <app-jurormenu></app-jurormenu>
  <div class="row">
    <div class="col">
      <app-nav-entries [useShow]='false' (gotoEntry)='onNavChanged($event)'></app-nav-entries>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <app-judge-entry *ngIf='entry' [entry]='entry' (selectEntry)='onJurorSelection($event)'></app-judge-entry>
    </div>
  </div>
</ng-container>
<ng-container *ngIf="1 && router.url === '/peak'">
  <app-unrated></app-unrated>
</ng-container>